import { Card, Col, DatePicker, Divider, Flex, Form, Row } from 'antd'
import { FormInstance } from 'antd/lib'

import { Text } from 'src/components'
import {
  TreatmentsConsumablesTables,
  RecipesConsumablesTables
} from 'src/features/persons/components/PersonConsultations'
import { dayMonthYearBackSlash } from 'src/libs'
import { useLocales } from 'src/locales'

import { useStyles } from './styles'

type Props = {
  form: FormInstance
}

export const RecipesBody = ({ form }: Props) => {
  const { t } = useLocales()

  const { styles } = useStyles()

  return (
    <Flex gap={16} vertical>
      <Card>
        <Card bordered className={styles.treatmentCard}>
          <Row gutter={[24, 24]} className={styles.treatmentContent}>
            <Col span={12}>
              <Form.Item
                name="created"
                label={t('stock_applications.request_date')}
              >
                <DatePicker
                  className="full-width"
                  format={dayMonthYearBackSlash}
                  placeholder={t('stock_applications.request_date')}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="endDate"
                label={t('stock_administration.release_date')}
              >
                <DatePicker
                  className="full-width"
                  format={dayMonthYearBackSlash}
                  placeholder={t('stock_administration.release_date')}
                />
              </Form.Item>
            </Col>
          </Row>
          <Divider />
          <Flex key={1} vertical gap={24} className={styles.treatmentContent}>
            <Text size="xl">{t('persons.treatment.treatment_prescribed')}</Text>

            <Form.Item name="medicine">
              <Form.List name="medicine">
                {(fields, { remove }) => (
                  <TreatmentsConsumablesTables
                    fields={fields}
                    remove={remove}
                    form={form}
                  />
                )}
              </Form.List>
            </Form.Item>
          </Flex>
          <Divider />

          <Flex key={1} vertical gap={24} className={styles.treatmentContent}>
            <Text size="xl">{t('recipes.administred_treatment')}</Text>

            <Form.Item name="recipesMedicine">
              <Form.List name="recipesMedicine">
                {(fields, { remove }) => (
                  <RecipesConsumablesTables
                    fields={fields}
                    remove={remove}
                    form={form}
                    isFinished
                  />
                )}
              </Form.List>
            </Form.Item>
          </Flex>
        </Card>
      </Card>
    </Flex>
  )
}
